// Year-on-year trends across the 3Es

export const YOY_BENEFICIARIES = [
  { fy: "FY 21-22", employability: 2800, entrepreneurship: 7500, environment: 280 },
  { fy: "FY 22-23", employability: 3400, entrepreneurship: 9800, environment: 410 },
  { fy: "FY 23-24", employability: 4200, entrepreneurship: 13100, environment: 320 },
  { fy: "FY 24-25", employability: 7200, entrepreneurship: 18300, environment: 520 },
];

// Sanctioned amount (₹ Cr) per pillar per FY — totals align with YOY_SPEND_CR
export const YOY_SANCTIONED_CR = [
  { fy: "FY 21-22", employability: 6.4, entrepreneurship: 5.0, environment: 2.8 },
  { fy: "FY 22-23", employability: 8.4, entrepreneurship: 6.5, environment: 3.7 },
  { fy: "FY 23-24", employability: 9.9, entrepreneurship: 7.7, environment: 4.5 },
  { fy: "FY 24-25", employability: 11.9, entrepreneurship: 9.3, environment: 5.26 },
];

// % of sanctioned that has been disbursed / utilised (older FYs trend higher;
// current FY is still in-flight so utilisation lags).
export const SANCTIONED_BREAKDOWN_RATIOS = {
  "FY 21-22": { disb: 0.96, util: 0.91 },
  "FY 22-23": { disb: 0.93, util: 0.85 },
  "FY 23-24": { disb: 0.88, util: 0.74 },
  "FY 24-25": { disb: 0.72, util: 0.55 },
};

export const YOY_SPEND_CR = [
  { fy: "FY 21-22", spend: 14.2, target: 15 },
  { fy: "FY 22-23", spend: 18.6, target: 19 },
  { fy: "FY 23-24", spend: 22.1, target: 22 },
  { fy: "FY 24-25", spend: 26.46, target: 27 },
];

export const YOY_TREES = [
  { fy: "FY 21-22", trees: 45000 },
  { fy: "FY 22-23", trees: 120000 },
  { fy: "FY 23-24", trees: 200000 },
  { fy: "FY 24-25", trees: 450000 },
];
